import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEquiposRadiologicos, getSustancias, getUnidadesDeMedida, } from "../../../../../redux/actions/resolucion";
import DataLabel from "../../../../commons/labels/DataLabel";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import CustomStepper from "../../../../commons/stepper/CustomStepper";
import { StyledResolucion } from "../../../../styled/Prevencion";
import SustanciasFormPart1Container from "./part1/SustanciasFormPart1Container";
import NewEquipoRadiologicoContainer from "./part2/equipoRadiologico/NewEquipoRadiologicoContainer";
import ProveedoresTableContainer from "./part3/ProveedoresTableContainer";
import EstudiosAmbientalesTableContainer from "./part4/EstudiosAmbientalesTableContainer";
import UsosTableContainer from "./part5/UsosTableContainer";

const SustanciasFormContainer = ({
  handleCancelSustancia,
  submitSustancia,
  idDependenciaEmpleador,
}) => {
  const dispatch = useDispatch();

  const sustancias = useSelector((state) => state.resolucion.sustancias);
  const sustancia = useSelector((state) => state.resolucion.abmSustancia);
  const unidadDeMedida = useSelector(
    (state) => state.resolucion.unidadDeMedida
  );

  const [formPart, setFormPart] = useState("Part1");
  const [contador, setContador] = useState(0);
  const totalGrupos = 5;
  const stepper = useMemo(() => {
    return <CustomStepper withStep contador={contador} maxGrupos={totalGrupos} />
  }, [contador, totalGrupos])

  const handleSustanciaFinalSubmit = () => {
    const { idTabla, ...submitData } = sustancia;
    submitSustancia(submitData, idTabla);
  };

  useEffect(() => {
    // Load sustancias
    dispatch(getSustancias());
    // Load unidad de medida
    dispatch(getUnidadesDeMedida());
    // Load Equipo radiologico
    dispatch(getEquiposRadiologicos(idDependenciaEmpleador));
  }, [dispatch, idDependenciaEmpleador]);

  if (sustancias.loading || unidadDeMedida.loading) {
    return (
      <StyledResolucion.LoadingContainer>
        {" "}
        <CircularLoading />{" "}
      </StyledResolucion.LoadingContainer>
    );
  }
  const handleNextStep = (step) => {
    setFormPart(step);
    setContador((prevContador) => prevContador + 1);
  };

  const handlePreviousStep = (step) => {
    setFormPart(step);
    setContador((prevContador) => prevContador - 1);
  };


  return (
    <>

      {
        formPart !== "Part1" && (
          <StyledResolucion.FormsContainer>
            <DataLabel
              firstText={"Nombre Comercial: " + sustancia.sustancia.nombre}
              secondText={"Sustancia: " + sustancia.sustancia.descripcionAgente}
            />
          </StyledResolucion.FormsContainer>
        )
      }
      {
        {
          Part1: (
            <SustanciasFormPart1Container
              setFormPart={handleNextStep}
              handleCancelSustancia={handleCancelSustancia}
              stepper={stepper}
            />
          ),
          Part2: (
            <NewEquipoRadiologicoContainer
              handlePreviousStep={handlePreviousStep}
              setFormPart={handleNextStep}
              stepper={stepper}
            />
          ),
          Part3: (
            <ProveedoresTableContainer
              handlePreviousStep={handlePreviousStep}
              handleNextStep={handleNextStep}
              stepper={stepper}
            />
          ),
          Part4: (
            <EstudiosAmbientalesTableContainer
              handlePreviousStep={handlePreviousStep}
              handleNextStep={handleNextStep}
              stepper={stepper}
            />
          ),
          Part5: (
            <UsosTableContainer
              handlePreviousStep={handlePreviousStep}
              handleNextStep={handleSustanciaFinalSubmit}
              stepper={stepper}
            />
          )
        }[formPart]
      }

    </>
  );
};

export default SustanciasFormContainer;
